import { MsgLiquidStakeSDKType } from 'stridejs/dist/types/codegen/stride/stakeibc/tx'
import { MetaDataHandlerParameters } from './types'
import { CHAIN_INFO_LIST } from '@/config'

const handleLiquidStake = ({ message, denom }: MetaDataHandlerParameters<MsgLiquidStakeSDKType>): boolean => {
  // We'll exclude liquid stake tx that did not come from the selected chain.
  return message.host_denom === CHAIN_INFO_LIST[denom].stakeCurrency.coinMinimalDenom
}

export { handleLiquidStake }
